import ArticleService from '../services/article.service';
import MessageService from '../services/message.service';
import { initialState, defaultActions, defaultMutations, defaultGetters } from './common.module';

export const articleModule = {
  namespaced:true,
  state: initialState(),  // mix with custom state if needed
  mutations: {
    ...defaultMutations()
    // add custom mutations
  },
  getters: {
    ...defaultGetters()
    // add custom getters
  },
  actions: {
    ...defaultActions(),
    loadItems({commit, state}, primary=true) {
      commit('SAVE_LOADING', true);
      // replace here by the real service
      ArticleService.getItems(state.options.sortBy, state.options.sortDesc, state.options.page, state.options.itemsPerPage, state.filter).then(response => {
        if (primary) {
          // this load concerns the main component => it's not a load to populate a subcomponent, we need to check the options
          // check if current options are still valid : last load may have changed the number of items, so current page may not be valid for example
          let nbpages = Math.ceil(response.total/state.options.itemsPerPage);
          if (nbpages<state.options.page) {
            let newOptions = state.options;
            if (nbpages>0) {
              newOptions.page = nbpages;
            } else {
              newOptions.page = 1;
            }
            commit('SAVE_OPTIONS',newOptions);
          }
        }
        commit('SAVE_ITEMS', response);
      }).catch( () => {
        commit('SAVE_ERROR', true);
      }).finally( () => {
        commit('SAVE_LOADING', false);
      });
    },
    loadItem({commit, state}, { id, fields} ) {
      // clear item if given id is different than current id
      if (state.item && state.item.id && id != state.item.id) {
        commit('SAVE_ITEM', null);
      }
      commit('SAVE_LOADING', true);
      // replace here by the real service
      ArticleService.getItem(id).then(response => {
        // complete the item with potential nullable fields that were not retrieved
        fields.forEach( item => {
          if (response[item] === undefined) {
            response[item] = null;
          }
        });
        commit('SAVE_ITEM', response);
      }).catch( () => {
        MessageService.error('loaded','article');
        commit('SAVE_ERROR', true);
      }).finally( () => {
        commit('SAVE_LOADING', false);
      });
    },
    postItem( { commit }, item) {
      // rename sections (for technical reasons, 'sections' is a readonly property from the admin point of view)
      Object.defineProperty(item, 'asections', Object.getOwnPropertyDescriptor(item, 'sections'));
      delete item.sections;
      commit('SAVE_LOADING', true);
      ArticleService.postItem(item).then( response => {
        commit('SAVE_ITEM', response);
        MessageService.success('created','article');
      }).catch( () => {
        MessageService.error('created','article');
        commit('SAVE_ERROR', true);
      }).finally( () => {
        commit('SAVE_LOADING', false);
      });
    },
    patchItem({commit}, data) {
      const { id, item } = data;
      // rename sections (for technical reasons, 'sections' is a readonly property from the admin point of view)
      if (item.sections) {
        Object.defineProperty(item, 'asections', Object.getOwnPropertyDescriptor(item, 'sections'));
        delete item.sections;  
      }
      commit('SAVE_LOADING', true);
      ArticleService.patchItem(id, item).then(response => {
        commit('SAVE_ITEM', response);
        MessageService.success('updated','article');
      }).catch( () => {
        MessageService.error('updated','article');
        commit('SAVE_ERROR', true);
      }).finally( () => {
        commit('SAVE_LOADING', false);
      });
    },
    deleteItem({commit}, id) {
      commit('SAVE_LOADING', true);
      ArticleService.deleteItem(id).then( () => {
        MessageService.success('deleted','article');
        commit('SAVE_ITEM', null);
      }).catch( () => {
        MessageService.error('deleted','article');
        commit('SAVE_ERROR', true);
      }).finally( () => {
        commit('SAVE_LOADING', false);
      });
    }
  }
};
